import styled from 'foundations-theming-specialty/utils';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PopoverWrapper = styled.div.withConfig({
  displayName: "MobilePopover__PopoverWrapper"
})(["position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;background-color:", ";display:flex;flex-direction:column;align-items:stretch;"], ({
  theme
}) => theme.color['fill-surface-default']);
export const MobilePopover = ({
  children,
  onOpenChange,
  open,
  title,
  content,
  footer
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, open && /*#__PURE__*/_jsxs(PopoverWrapper, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        padding: "600",
        borderBlockEndWidth: "100",
        borderBlockEndStyle: "solid",
        borderBlockEndColor: "border-core-disabled",
        flex: "0 0 auto",
        gap: "600",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          textAlign: "center",
          color: "text-core-default",
          children: title
        }), /*#__PURE__*/_jsx(CloseButton, {
          onClick: () => onOpenChange(false),
          color: "text-core-default"
        })]
      }), /*#__PURE__*/_jsx(Box, {
        flex: "1 1 auto",
        overflowY: "auto",
        children: content
      }), footer && /*#__PURE__*/_jsx(View, {
        boxShadow: "100",
        padding: "600",
        flex: "0 0 auto",
        children: footer
      })]
    })]
  });
};